import { render } from "./IconBase.vue?vue&type=template&id=66f56ed3&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"

import "./IconBase.vue?vue&type=style&index=0&id=66f56ed3&scoped=true&lang=css"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f56ed3"]])

export default __exports__